import React, { useEffect } from 'react';
import { useAIVideoStore } from '@/hooks/use-ai-video-store';
import Step1Landing from '@/components/ai-video/steps/Step1Landing';
import Step2VideoGoal from '@/components/ai-video/steps/Step2VideoGoal';
import Step3Experience from '@/components/ai-video/steps/Step3Experience';
import Step4Challenge from '@/components/ai-video/steps/Step4Challenge';
import Step5AIPromise from '@/components/ai-video/steps/Step5AIPromise';
import Step6Impact from '@/components/ai-video/steps/Step6Impact';
import Step7AIFamiliarity from '@/components/ai-video/steps/Step7AIFamiliarity';
import Step8Loading from '@/components/ai-video/steps/Step8Loading';
import Step9Email from '@/components/ai-video/steps/Step9Email';
import Step10Payment from '@/components/ai-video/steps/Step10Payment';
import Step11ThankYou from '@/components/ai-video/steps/Step11ThankYou';
const AIVideoOnboarding: React.FC = () => {
  const {
    currentStep,
    setCurrentStep,
    setAnswer,
    nextStep,
    previousStep,
    answers
  } = useAIVideoStore();

  // Scroll to top when step changes
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, [currentStep]);

  // Debug logging
  console.log('Current Step:', currentStep);
  console.log('Current Answers:', answers);
  const handleAnswer = (key: keyof typeof answers, value: string) => {
    setAnswer(key, value);
    nextStep();
  };
  const renderStep = () => {
    console.log('Rendering step:', currentStep);
    switch (currentStep) {
      case 1:
        return <Step1Landing onNext={nextStep} />;
      case 2:
        return <Step2VideoGoal onNext={answer => handleAnswer('videoGoal', answer)} onBack={previousStep} />;
      case 3:
        return <Step3Experience onNext={answer => handleAnswer('experience', answer)} onBack={previousStep} />;
      case 4:
        return <Step4Challenge onNext={answer => handleAnswer('challenge', answer)} onBack={previousStep} />;
      case 5:
        return <Step5AIPromise onNext={nextStep} onBack={previousStep} />;
      case 6:
        return <Step6Impact onNext={answer => handleAnswer('impact', answer)} onBack={previousStep} />;
      case 7:
        return <Step7AIFamiliarity onNext={answer => handleAnswer('aiFamiliarity', answer)} onBack={previousStep} />;
      case 8:
        return <Step8Loading onNext={nextStep} onBack={previousStep} />;
      case 9:
        console.log('Rendering Step9Email with answers:', answers);
        return <Step9Email onNext={nextStep} onBack={previousStep} answers={answers} />;
      case 10:
        return <Step10Payment onNext={nextStep} onBack={previousStep} answers={answers} />;
      case 11:
        return <Step11ThankYou />;
      default:
        return <Step1Landing onNext={nextStep} />;
    }
  };
  return <div className="w-full">
      {/* Debug controls */}
      
      {renderStep()}
    </div>;
};
export default AIVideoOnboarding;